import { buttonGroupClasses, type ButtonGroupProps } from '@mui/material';
import { Theme } from '@mui/material/styles';

const COLORS = [
  'primary',
  'secondary',
  'info',
  'success',
  'warning',
  'error',
  'purple',
] as const;

// NEW VARIANT
declare module '@mui/material/ButtonGroup' {
  interface ButtonGroupPropsVariantOverrides {
    soft: false;
    bordered: true;
    contained: false;
    text: false;
  }
}

export default function ButtonGroup(theme: Theme) {
  const rootStyles = (ownerState: ButtonGroupProps) => {
    const inheritColor = !ownerState.color || ownerState.color === 'inherit';

    const outlinedVariant = ownerState.variant === 'outlined';

    const borderedVariant = ownerState.variant === 'bordered';

    const horizontalOrientation = ownerState.orientation === 'horizontal';

    const verticalOrientation = ownerState.orientation === 'vertical';

    const smallSize = ownerState.size === 'small';

    const mediumSize = ownerState.size === 'medium';

    const largeSize = ownerState.size === 'large';

    const defaultStyle = {
      borderWidth: '1px',
      padding: theme.spacing(0.5),
      gap: theme.spacing(0.5),
      ...((borderedVariant || outlinedVariant) && {
        borderStyle: 'solid',
        borderColor: theme.palette.grey[300],
        ...(inheritColor && {
          backgroundColor: 'white',
          borderColor: theme.palette.grey[300],
        }),
      }),

      [`& .${buttonGroupClasses.grouped}`]: {
        height: '100%',
        border: 'none',
        padding: theme.spacing(0.5),
        // minWidth: 'auto',
        '&:hover': {
          backgroundColor: 'inherit',
          '& > .Icon': {
            color: theme.palette.primary[400],
          },
        },

        '&:not(:last-of-type)': {
          ...(borderedVariant && {
            borderStyle: 'solid',
            borderColor: theme.palette.grey[300],
            ...(inheritColor && {
              borderColor: theme.palette.grey[300],
            }),
            // HORIZONTAL
            ...(horizontalOrientation && {
              borderWidth: '0px 1px 0px 0px',
            }),
            // VERTICAL
            ...(verticalOrientation && {
              borderWidth: '0px 0px 1px 0px',
            }),
          }),
          /* ...(outlinedVariant && {
            borderStyle: 'solid',
            ...(inheritColor && {
              borderColor: alpha(theme.palette.grey[500], 0.32),
            }),
            // HORIZONTAL
            ...(horizontalOrientation && {
              borderWidth: '0px 1px 0px 0px',
            }),
            // VERTICAL
            ...(verticalOrientation && {
              borderWidth: '0px 0px 1px 0px',
            }),
          }), */
        },
      },
    };

    const colorStyle = COLORS.map((color) => ({
      [`& .${buttonGroupClasses.grouped}`]: {
        /* '&:not(:last-of-type)': {
          ...(!outlinedVariant && {
            ...(ownerState.color === color && {
              // SOFT
              ...(borderedVariant && {
                borderColor: alpha(theme.palette[color].dark, 0.24),
              }),
            }),
          }),
        }, */
      },
    }));

    const size = {
      borderRadius: theme.spacing(0.5),

      ...(smallSize && {
        height: 24,
        [`& .${buttonGroupClasses.grouped}`]: {
          minWidth: `${theme.spacing(3)}!important`,
          '& > svg': {
            width: theme.spacing(2),
            height: theme.spacing(2),
          },
        },
      }),
      ...(mediumSize && {
        height: 32,
        [`& .${buttonGroupClasses.grouped}`]: {
          minWidth: `${theme.spacing(4)}!important`,
          '& > svg': {
            width: theme.spacing(2),
            height: theme.spacing(2),
          },
        },
      }),
      ...(largeSize && {
        height: 40,
        borderRadius: theme.spacing(1),
        [`& .${buttonGroupClasses.grouped}`]: {
          minWidth: `${theme.spacing(5)}!important`,
          '& > svg': {
            width: theme.spacing(2.5),
            height: theme.spacing(2.5),
          },
        },
      }),
    };

    const disabledState = {
      [`& .${buttonGroupClasses.grouped}`]: {
        [`&.${buttonGroupClasses.disabled}`]: {
          '&:not(:last-of-type)': {
            borderColor: theme.palette.action.disabledBackground,
          },
        },
      },
    };

    return [defaultStyle, ...colorStyle, disabledState, size];
  };

  return {
    MuiButtonGroup: {
      defaultProps: {
        disableElevation: true,
      },

      styleOverrides: {
        root: ({ ownerState }: { ownerState: ButtonGroupProps }) =>
          rootStyles(ownerState),
      },
    },
  };
}
